import {InventoryCellSprite} from "./InventoryCell.sprite";

export class Sprite_MainInvItems extends KDCore.Sprite {
  constructor() {
    super();
    this.isLockable = true;
    this._create();
  }

  drawItemName(text) {
    if (!this._textSpr) return;

    this._textSpr.clear();
    this._textSpr.drawTextFull(text, this.settings.itemName.position);
  }

  getCellAt(index) {
    return this._cells[index];
  }

  getHoveredCell() {
    if (this.focusedCell) return null;

    for (let i = 0; i < this._cells.length; i++) {
      const cell = this._cells[i];
      if (cell.isHovered()) {
        return cell;
      }
    }

    return null;
  }

  clearAllItems() {
    this.clearFocus();

    for (let i = 0; i < this._cells.length; i++) {
      this._cells[i].clear();
    }
  }

  prepareForCategory(categoryIndex) {
    for (let i = 0; i < this._cells.length; i++) {
      this._cells[i].prepareForCategory(categoryIndex);
    }
  }

  showFocusLayer() {
    const width = this.settings.invCellMarginX * 5;
    const height = this.settings.invCellMarginY * 5;
    this._focusLayer = KDCore.Sprite.FromBitmap(width, height);

    //@_focusLayer.move -1, -1
    this._focusLayer.bitmap.fillAll(KDCore.Color.BLACK);
    this._focusLayer.opacity = 180;

    this.content.addChild(this._focusLayer);
    $gameTemp._pkdMICellFocused = true;
  };

  showFocusedItem(cell, itemCount) {
    this.focusedCell = new InventoryCellSprite(cell.index)
    this.focusedCell.move(cell.x, cell.y);
    this.focusedCell.setFocusItem(cell.item, itemCount);

    this._focusLayer.addChild(this.focusedCell);
  };

  isFocused() {
    return !!this._focusLayer;
  }

  clearFocus() {
    if (!this.isFocused()) {
      return;
    }

    this.content.removeChild(this._focusLayer);
    this._focusLayer.visible = false;
    this._focusLayer.destroy();
    this._focusLayer = null;

    //@focusedCell?.destroy()
    this.focusedCell = null;
    return $gameTemp._pkdMICellFocused = false;
  };

  updateClearFocusClick() {
    if (TouchInput.isTriggered()) {
      if (this.content.isMouseInFocusZone()) {
        this.clearFocus();
      }
    }
  };

  isMouseInFocusZone() {
    if (this.focusedCell.isHovered()) return false;
    if (this._isSliderIsHovered()) return false;

    const pos = TouchInput;
    const rx = KDCore.SDK.canvasToLocalX(this._focusLayer, pos.x);
    const ry = KDCore.SDK.canvasToLocalY(this._focusLayer, pos.y);
    return rx >= 0 && ry >= 0 && rx <= this._focusLayer.width && ry <= this._focusLayer.height;
  };

  _create() {
    this._loadSettings();
    this._createItemNameLine();
    this._createContent();
  }

  _loadSettings() {
    return this.settings = this._settingsJSON();
  }

  _settingsJSON() {
    return YsServices.equipmentService.getUIMapInventorySettings();
  }

  _createItemNameLine() {
    this._textSpr = KDCore.Sprite.FromBitmap(this.settings.itemName.textBoxWidth, this.settings.itemName.textBoxHeight);
    this.applyTextSettingsByExtraSettings(this._textSpr, this.settings.itemName);

    this.add(this._textSpr);
  }

  _createContent() {
    this.content = new Sprite();
    this._createCells();
    this.content.move(KDCore.Utils.jsonPos(this.settings.invCellStartPosition));
    this.add(this.content);
  }

  _createCells() {
    let i, j, k, ref;
    this._cells = [];
    let index = 0;

    const params = YsServices.equipmentService.getSizeCellsParameter();
    const rows = params.rowsPerPage;
    const columns = params.columnsPerPage;

    for (i = k = 0, ref = rows; (0 <= ref ? k < ref : k > ref); i = 0 <= ref ? ++k : --k) {
      let l, ref1;
      for (j = l = 0, ref1 = columns; (0 <= ref1 ? l < ref1 : l > ref1); j = 0 <= ref1 ? ++l : --l) {
        const cell = this._createCell(index++);
        this._cells.push(cell);
        this._placeCell(i, j, cell);
      }
    }
  }

  _createCell(index) {
    const cell = new InventoryCellSprite(index, this._isCellsCanBeLocked());
    this.content.addChild(cell);
    return cell;
  }

  _isCellsCanBeLocked() {
    return this.isLockable;
  }

  _placeCell(y, x, cell) {
    cell.move(this.settings.invCellMarginX * x, this.settings.invCellMarginY * y);
  }
}
